import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ags-activity-card',
  templateUrl: './activity-card.component.html',
  styleUrls: ['./activity-card.component.scss']
})
export class ActivityCardComponent implements OnInit {
  @Input() number: number;
  @Input() title: string;
  @Input() text: string;
  @Input() textButton: string;

  constructor() {}

  ngOnInit() {}
}
